import React from 'react';
import worldicon from '../../../../../assets/img/icons/world_icon.fw.png';
import useExpiredCustomers from '../../../../../hooks/shared/customers/useExpiredCustomers';

const TotalExpiredCustomers = () => {
  const {
    state: { totalExpired },
  } = useExpiredCustomers();

  return (
    <div className="col-lg col-md col-sm">
      <div className="boxes">
        <div className="text-center">
          <div className="text-center mt-3">
            <img src={worldicon} alt="" />
          </div>
          <div className="count">{totalExpired}</div>
          <h3 className="color-four">Total Expired</h3>
        </div>
      </div>
    </div>
  );
};

export default TotalExpiredCustomers;
